import { ChartGroupType } from './chart-group-type';
import { Rule } from 'ngx-angular-query-builder';

export class ArrearsDrillDownParams {
  dropDown1: ChartGroupType;
  dropDown2: ChartGroupType;
  rule: Rule;
}
